import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import CtaLink from 'components/essentials/Cta/CtaLink';
import TextPlaceholder from 'components/consumer/TextPlaceholder';
const ItemPlaceholder = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <span><TextPlaceholder className="w-1/2 md:!w-[50px] !inline-flex !mt-1 md:!mt-0" /></span>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
const BreadcrumbItem = props => {
  const $ = _c(22);
  const {
    link,
    loading: t0,
    isLast: t1,
    backIcon: t2,
    withSchema: t3
  } = props;
  const loading = t0 === undefined ? false : t0;
  const isLast = t1 === undefined ? false : t1;
  const backIcon = t2 === undefined ? false : t2;
  const withSchema = t3 === undefined ? true : t3;
  let t4;
  if ($[0] !== withSchema) {
    t4 = withSchema ? {
      itemProp: "itemListElement",
      itemScope: true,
      itemType: "https://schema.org/ListItem"
    } : {};
    $[0] = withSchema;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const listItemSchema = t4;
  let t5;
  if ($[2] !== withSchema) {
    t5 = withSchema ? {
      itemScope: true,
      itemType: "https://schema.org/Thing",
      itemProp: "item"
    } : {};
    $[2] = withSchema;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const thingSchema = t5;
  let t6;
  if ($[4] !== withSchema) {
    t6 = withSchema ? {
      itemProp: "name"
    } : {};
    $[4] = withSchema;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const nameSchema = t6;
  let t7;
  if ($[6] !== backIcon || $[7] !== isLast || $[8] !== link || $[9] !== loading || $[10] !== nameSchema || $[11] !== props.backArrowIcon || $[12] !== props.label || $[13] !== thingSchema) {
    t7 = isLast ? <span {...thingSchema}>{loading ? <ItemPlaceholder /> : <span {...nameSchema} className="text-xs">{props.label}</span>}</span> : loading ? <div><ItemPlaceholder /></div> : <span className={classNames({
      "before:p-2 before:text-gray-light1 before:animate-fade-in-ease before:content-['<'] text-xs": props.backArrowIcon
    })}><CtaLink {...thingSchema} styling="link" hasArrow={false} color="black" to={link} isBold={false}>{backIcon ? <span className="text-xl mr-2 align-middle">←</span> : null}{loading ? <ItemPlaceholder /> : <span {...nameSchema} className="text-gray-light1 [a:hover_&]:text-brand [a:hover_&]:underline text-xs">{props.label}</span>}</CtaLink></span>;
    $[6] = backIcon;
    $[7] = isLast;
    $[8] = link;
    $[9] = loading;
    $[10] = nameSchema;
    $[11] = props.backArrowIcon;
    $[12] = props.label;
    $[13] = thingSchema;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== props.index || $[16] !== withSchema) {
    t8 = withSchema && <meta itemProp="position" content={props.index + 1} />;
    $[15] = props.index;
    $[16] = withSchema;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== listItemSchema || $[19] !== t7 || $[20] !== t8) {
    t9 = <li {...listItemSchema} className="inline-block before:relative before:top-px before:left-0 before:text-xs before:p-2 before:text-gray-light1 before:animate-fade-in-ease before:content-['>'] first:before:hidden">{t7}{t8}</li>;
    $[18] = listItemSchema;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  return t9;
};
BreadcrumbItem.propTypes = {
  loading: PropTypes.bool,
  link: PropTypes.string,
  label: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  isLast: PropTypes.bool,
  backIcon: PropTypes.bool,
  backArrowIcon: PropTypes.bool,
  withSchema: PropTypes.bool
};
export default BreadcrumbItem;